import { axiosInstance } from "../network";
import axios from "axios";
import { API_URL } from "../../constants";

export default {
  signUp: (data) => {
    return axios.post(API_URL.SIGN_UP, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  login: (data) => {
    return axios.post(API_URL.LOGIN, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  resend24: ( id) => {
    return axios.post(`${API_URL.RESEND_24}/${id}`, {}, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  logoutUser: (data) => {
    return axiosInstance.post(API_URL.LOGOUT, data);
  },
  refreshToken: () => {
    return axiosInstance.post(API_URL.REFRESH_TOKEN, {});
  },
  changePassword: (data) => {
    return axiosInstance.post(API_URL.CHANGE_PASSWORD, data);
  },
  forgotVerifyPassword: (data) => {
    return axios.post(API_URL.FORGOT_VERIFY, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  userVerify: (id) => {
    return axiosInstance.post(`${API_URL.USER_DATA}/${id}`, {});
  },
  setPassword: (data) => {
    return axios.post(API_URL.SET_PASSWORD, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  forgotPassword: (data) => {
    return axios.post(API_URL.FORGOT_PASSWORD, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  validateToken: (data) => {
    return axiosInstance.post(API_URL.VALIDATE_TOKEN, data);
  },
};
